export function getAppOrigin(): string {
  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin
  }

  return (import.meta.env.VITE_BASE_URL as string | undefined) ?? ''
}

export function getAppRedirectUri(path = '/redirect'): string {
  return `${getAppOrigin().replace(/\/$/, '')}${path}`
}
